import { socket } from "../index";
import { openConfirm } from "../../atoms/common";
import { getRecoil } from "recoil-nexus";
import roomDetailState from "../../atoms/roomDetail";
import myInfoState from "../../atoms/myinfo";

interface ListenReceiveProjectStartedPayload {
  roomId: string;
  projectPrice: number;
  projectType: string;
  projectStartAmount: number;
  projectTargetAmount: number;
}

const listenReceiveProjectStarted = () => {
  socket?.on('RECEIVE_PROJECT_STARTED', (payload: ListenReceiveProjectStartedPayload) => {
    const roomDetail = getRecoil(roomDetailState);
    const myInfo = getRecoil(myInfoState);

    if (roomDetail.id === '' || roomDetail.id === undefined || roomDetail.id === 'square' || myInfo.ownRoomId?.split('|').includes(roomDetail.id)) {
      return;
    }

    openConfirm(
      '방장이 프리미엄를 시작했습니다.'
      + `<br/>참가비는 ${payload.projectPrice.toLocaleString()}보석이며, 해당 프리미엄에 참가하시러면 확인 버튼을 클릭해주세요.`
      + `<br/><br/>프리미엄 타입: ${payload.projectType}`
      + `<br/>프리미엄 시작 금액: ${payload.projectStartAmount.toLocaleString()}`
      + `<br/>프리미엄 목표 금액: ${payload.projectTargetAmount.toLocaleString()}`,
      () => {
        window.location.href = `/chatting-app/room/${payload.roomId}?password=${new URL(window.location.href).searchParams.get('password')}`;
      },
      () => {
        window.location.href = '/chatting-app/waiting-room';
      }
    );
  });
}

export default listenReceiveProjectStarted;